import BuyLottery from "./buy-lottery/index";

export default BuyLottery;
